import { createInertiaApp } from '@inertiajs/react';
import { createElement } from 'react';
import { createRoot } from 'react-dom/client';
import Layout from '../layouts/Application';
import { renderApp } from '@inertiaui/modal-react';

void createInertiaApp({
  resolve: (name): any => {
    const pages = import.meta.glob<any>('../pages/**/*.tsx', { eager: true });
    const page = pages[`../pages/${name}.tsx`];
    page.default.layout =
      page.default.layout ||
      ((page: any) => {
        return createElement(Layout, page.props || {}, page);
      });
    return page;
  },

  setup({ el, App, props }) {
    const root = createRoot(el);
    root.render(renderApp(App, props));
  },
});
